import { defineMessage } from 'services/localization';

export const messages = {
    invitedBy: defineMessage('user_invited_you_to_join'),
    declineAction: defineMessage('decline'),
    acceptAction: defineMessage('accept_invitation'),
};
